import { concat, fn, hash } from '@ember/helper';

import { t } from 'ember-intl';

import Checkbox from 'umg-ember-backend/components/ui/form/field/checkbox';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';
import Td from './td';
import Th from './th';

const bem = getBem(styles);

const isSelected = (selectedRecords, record) => {
  return selectedRecords?.includes(record);
};

<template>
  <table class={{(bem)}} ...attributes>
    <thead class={{bem 'thead'}} data-test-table-thead>
      <tr class={{bem 'tr'}} data-test-table-tr>
        {{#if @onAssignRelation}}
          <th class={{bem 'th'}} data-test-table-th></th>
        {{/if}}
        <th class={{bem 'th'}} data-test-table-th></th>
        {{#each @columns as |column|}}
          <Th
            @column={{column}}
            @recordType={{@recordType}}
            @activeSort={{@activeSort}}
            @onUpdateSort={{@onUpdateSort}}
          />
        {{/each}}
        <Th @column={{hash type='row-actions'}} />
      </tr>
    </thead>

    <tbody class={{bem 'tbody'}} data-test-table-tbody>
      {{#each @records as |record|}}
        <tr
          class={{bem
            'tr'
            (hash is-selected=(isSelected @selectedRecords record))
          }}
          data-test-table-tr
        >
          {{#if @onAssignRelation}}
            <td class={{bem 'td'}} data-test-table-td>
              <Checkbox
                @fieldId={{concat 'record-' record.id}}
                @style='check'
                @isChecked={{isSelected @selectedRecords record}}
                @onChange={{fn @onSelectRecord record}}
              />
            </td>
          {{/if}}
          <Td @column={{hash type='row-status'}} @record={{record}} />
          {{#each @columns as |column|}}
            <Td @column={{column}} @record={{record}} />
          {{/each}}
          <Td
            @column={{hash type='row-actions'}}
            @record={{record}}
            @recordActions={{@recordActions}}
          />
        </tr>
      {{else}}
        <tr>
          <td colspan='100%' class={{bem 'no-records'}}>
            {{t 'tables.no-records'}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>
